import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initTheme } from './lib/theme';

// ============================================================================
// PDF.JS WORKER CONFIGURATION (CRITICAL FOR VITE DEV + PROD PARITY)
// ----------------------------------------------------------------------------
// We use the ESM worker from pdfjs-dist v4+.
// The `new URL(..., import.meta.url)` pattern is the Vite-recommended way:
//   - In **dev** (Vite dev server): Vite serves the worker file through the
//     module graph with correct MIME + HMR safety. No pre-bundling issues.
//   - In **prod** (vite build): The worker is emitted as a hashed asset in
//     dist/assets/ (see pdf.worker.min-*.mjs) and the URL is rewritten.
// We deliberately configure ONCE here (early, before any PDF loading) rather
// than in PdfViewer/PdfPage. This avoids duplicate side-effects during HMR
// remounts and makes the setup easy to audit.
// See also: vite.config.ts (optimizeDeps.exclude: ['pdfjs-dist']) and
// client/src/vite-env.d.ts for module declaration.
// ============================================================================
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

initTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
